import { render, staticRenderFns } from "./CardListRestaurant.vue?vue&type=template&id=2066d714&scoped=true&"
import script from "./CardListRestaurant.vue?vue&type=script&lang=js&"
export * from "./CardListRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./CardListRestaurant.vue?vue&type=style&index=0&id=2066d714&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2066d714",
  null
  
)

export default component.exports